import type {Dispatch, SetStateAction} from "react";
import type {Color} from "../../../../generated/api/base";
import {EventNameForViewsChangeInLocalStorage} from "../../topbar/ViewTabsCommon";

export interface IViewItemPaletteState {
	readonly color: Color | null;
	readonly icon: string | null;
}

interface INavigationPanelDataTarget {
	readonly setNavigationPanelData: (data: {color?: string; icon?: string}) => void;
}

type SetPaletteState = Dispatch<SetStateAction<IViewItemPaletteState | null>>;

const notifyViewsChanged = () => {
	window.dispatchEvent(new Event(EventNameForViewsChangeInLocalStorage));
};

export const updateViewPaletteColor = (view: INavigationPanelDataTarget, setPaletteState: SetPaletteState, newColor: Color) => {
	view.setNavigationPanelData({color: newColor.hex});
	setPaletteState((prev) => ({
		color: newColor,
		icon: prev?.icon ?? null,
	}));
	notifyViewsChanged();
};

export const updateViewPaletteIcon = (view: INavigationPanelDataTarget, setPaletteState: SetPaletteState, iconName: string) => {
	view.setNavigationPanelData({icon: iconName});
	setPaletteState((prev) => ({
		color: prev?.color ?? null,
		icon: iconName,
	}));
	notifyViewsChanged();
};
